var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "favorites_hint_area" } }, [
    _c("div", [_vm._v(_vm._s(_vm.favorites_hint_text))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }